// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__16OnL","icon":"SortAdornment_icon__3f34s","up":"SortAdornment_up__1cnM0","down":"SortAdornment_down__1OxTT","active":"SortAdornment_active__EdEpr"};